import {
    SAVE_ASSET_DASHBOARD_TABLE_FILTERS,
    CLEAR_ASSET_DASHBOARD_TABLE_FILTERS,
    SAVE_ASSET_DASHBOARD_MAP_FILTERS,
    CLEAR_ASSET_DASHBOARD_MAP_FILTERS,
    DEFAULT_ASSET_DASHBOARD_MAP_FILTERS
} from "./constants";

const initialState = {
    assetTableFilters: {},
    mapFilters: { ...DEFAULT_ASSET_DASHBOARD_MAP_FILTERS }
};

export default (state = initialState, action) => {
    switch (action.type) {
        case SAVE_ASSET_DASHBOARD_TABLE_FILTERS:
            return { ...state, assetTableFilters: action.response || {} };
        case CLEAR_ASSET_DASHBOARD_TABLE_FILTERS:
            return { ...state, assetTableFilters: {} };
        case SAVE_ASSET_DASHBOARD_MAP_FILTERS:
            return { ...state, mapFilters: action.response || { ...DEFAULT_ASSET_DASHBOARD_MAP_FILTERS } };
        case CLEAR_ASSET_DASHBOARD_MAP_FILTERS:
            return { ...state, mapFilters: { ...DEFAULT_ASSET_DASHBOARD_MAP_FILTERS } };
        default:
            return state;
    }
};
